import React, { FC } from 'react';
import { IconButton, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

import { V1_ACCENT } from './theme';

// Shared V1 search box: accent search icon + an X clear button whenever there's
// text (Leo 2026-07-13). `disabled` renders the coming-soon placeholder variant
// (Notes — content search deferred to the extraction-table item).
export const V1SearchField: FC<{
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  disabled?: boolean;
}> = ({ value, onChange, placeholder, disabled }) => (
  <TextField
    size="small" fullWidth placeholder={placeholder} value={value} disabled={disabled}
    onChange={(e) => onChange(e.target.value)}
    sx={{ mb: 2, bgcolor: 'white', borderRadius: 2 }}
    InputProps={{
      startAdornment: <SearchIcon sx={{ color: disabled ? '#b9b9be' : V1_ACCENT, mr: 1 }} fontSize="small" />,
      endAdornment: value ? (
        <IconButton size="small" aria-label="Clear search" onClick={() => onChange('')} edge="end">
          <CloseIcon fontSize="small" />
        </IconButton>
      ) : undefined,
    }}
  />
);
